import { EPaymentLayoutConstant } from "./constants";
export var getMaxHeight = function getMaxHeight(size) {
  return size * EPaymentLayoutConstant.Height + Math.max(size - 1, 0) * EPaymentLayoutConstant.Gap;
};